module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-fixed-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-top-links navbar-right pull-right"
  }, [(_vm.$user.canSeeNotifications) ? _c('notifications') : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.logout'
      },
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "",
      "data-original-title": "Logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary ",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-31dc513b"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/TopBar.vue
// module id = 967
// module chunks = 0